import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import config from 'react-global-configuration';
import CryptoJS from 'crypto-js';
import $ from 'jquery';
import moment, { duration } from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
class Affiliates extends Component {
  constructor(props) {
    super(props);
    var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
    var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
    this.state = {
      reseller: [],
      affiliates: [],
      total_visitors: null, //for save total visitors
      total_leads: null, //for save total leads
      total_customers: null, //for save total customers
      partner_types: [],
      apiUrl: this.decryptconfigdata('apiUrl'),
      userAuthKey: has_local_data ? localdata.user_key : '',
      checkedDemoUser: localStorage.getItem('checkedDemoUser') ? localStorage.getItem('checkedDemoUser') : 0,
      activePage: 1,
      item_count: '',
      message: '',
      message12: '',
      res_search: '',
      select_product: '',
      sortingVisits: localStorage.getItem('sortingVisits') ? localStorage.getItem('sortingVisits') : '',
      sortingLeads: localStorage.getItem('sortingLeads') ? localStorage.getItem('sortingLeads') : '',
      sortingCustomers: localStorage.getItem('sortingCustomers') ? localStorage.getItem('sortingCustomers') : '',
      status: localStorage.getItem('status') ? localStorage.getItem('status') : '',
      application_type: localStorage.getItem('application_type') ? localStorage.getItem('application_type') : '',
      partdetails: '',
      resel_customer: '',
      isLoadMore: 1,
      start_dt: moment().startOf('month').format("YYYY-MM-DD"),
      end_dt: moment().format("YYYY-MM-DD"),
      loading: 1,
      waiting: [],
      start: moment().startOf('month'),
      end: moment(),
      iconStatusOfVisits: 'fa fa-arrow-up',
      iconStatusOfLeads: 'fa fa-arrow-up',
      iconStatusOfCustomers: 'fa fa-arrow-up'
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.keywordChange = this.keywordChange.bind(this);
    this.handleProductSelect = this.handleProductSelect.bind(this);
    this.affilatesList = this.affiliatesList.bind(this);
    this.datePickerChange = this.datePickerChange.bind(this);

  }
  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  withDateLeads(start_dt, end_dt) {
    console.log(start_dt);
    console.log(end_dt);
    var win = window.open(this.state.apiUrl + '/PartnerRest/ExportLeadsWithDate/start_dt/' + start_dt + '/end_dt/' + end_dt + '/userAuthKey/' + this.state.userAuthKey, '_blank');
    win.focus();
  }

  withOutDateLeads() {
    var win = window.open(this.state.apiUrl + '/PartnerRest/ExportLeads/userAuthKey/' + this.state.userAuthKey, '_blank');
    win.focus();
  }

  exportLeads() {
    { this.state.start_dt != '' && this.state.end_dt != '' ? this.withDateLeads(this.state.start_dt, this.state.end_dt) : this.withOutDateLeads() }
  }

  handlePageChange(pageNumber = 1) {
    this.setState({ loading: true });
    var totalPages = Math.ceil(this.state.item_count / 10);
    if (this.state.activePage != pageNumber) {
      $(document).ready(function () {
        $('.pages').addClass('disabled');
      });
      this.setState({ activePage: pageNumber, setPage: 'no' });
      fetch(this.state.apiUrl + '/PartnerRest/ManageAffiliates/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(this.state),
      })
        .then((Response) => Response.json())
        .then((findresponse) => {
          findresponse = this.rawjsonparse(findresponse, 1);
          $(document).ready(function () {
            $('.pages').removeClass('disabled');
            if (pageNumber == 1) {
              $('.first_page').addClass('disabled');
              $('.prev_page').addClass('disabled');
            }
            if (pageNumber == totalPages) {
              $('.next_page').addClass('disabled');
              $('.last_page').addClass('disabled');
            }
          });
          this.setState({
            loading: false,
            affiliates: findresponse.affiliates_data,
            total_visitors: findresponse.total_visitors,
            total_leads: findresponse.total_leads,
            total_customers: findresponse.total_customers,
            item_count: findresponse.iteam_counts,
            offset: findresponse.offset,
            off_count: findresponse.off_count,
            setPage: 'yes'
          })
        })
    }
  }

  affiliatesList(page = 1) {
    this.setState({ loading: true });
    fetch(this.state.apiUrl + '/PartnerRest/ManageAffiliates/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
      method: 'POST',
      dataType: 'json',
      body: JSON.stringify(this.state),
    })
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = this.rawjsonparse(findresponse, 1);
        // console.log(findresponse);
        // console.log(findresponse.affiliates_data);
        this.setState({
          loading: false,
          affiliates: findresponse.affiliates_data,
          total_visitors: findresponse.total_visitors,
          total_leads: findresponse.total_leads,
          total_customers: findresponse.total_customers,
          item_count: findresponse.iteam_counts,
          offset: findresponse.offset,
          off_count: findresponse.off_count,
          setPage: 'yes'
        })

      })
  }

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }
  rawjsonparse(findresponse, flg) {
    return findresponse;
  }

  //For search functionality
  keywordChange(event) {
    this.setState({ loading: true });
    var obj = this;
    this.setState({ res_search: event.target.value });
    //Delaying the function execute
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(function () {
      //Execute the function code here...
      obj.affiliatesList();
    }, 500);
  }

  //For product select functionality
  handleProductSelect(event) {
    this.setState({ loading: true });
    this.setState({ select_product: event.target.value });
    var obj = this;
    this.timer = window.setTimeout(function () {
      //Execute the function code here...
      obj.affiliatesList();
    }, 500);
  }

  datePickerChange(start, end) {
    this.setState({ start_dt: start, end_dt: end });
    console.log('date' + this.state.start_dt);
    this.affilatesList();
  }

  //export customer csv report
  exportCustomers(start_dt, end_dt, select_product) {
    console.log(start_dt);
    console.log(end_dt);
    var win = window.open(this.state.apiUrl + '/PartnerRest/ExportCustomers/start_dt/' + start_dt + '/end_dt/' + end_dt + '/select_product/' + select_product + '/userAuthKey/' + this.state.userAuthKey, '_blank');
    win.focus();
  }

  //export leads csv report
  exportLeads(start_dt, end_dt, select_product) {
    console.log(start_dt);
    console.log(end_dt);
    var win = window.open(this.state.apiUrl + '/PartnerRest/ExportLeadsWithDate/start_dt/' + start_dt + '/end_dt/' + end_dt + '/select_product/' + select_product + '/userAuthKey/' + this.state.userAuthKey, '_blank');
    win.focus();
  }

  //export partner leads report
  exportPartnerLeads(start_dt, end_dt, portaluser_id, select_product, portaluser_name) {
    var win = window.open(this.state.apiUrl + '/PartnerRest/ExportPartnerLeads/portaluser_id/' + portaluser_id + '/portaluser_name/' + portaluser_name + '/select_product/' + select_product + '/start_dt/' + start_dt + '/end_dt/' + end_dt + '/userAuthKey/' + this.state.userAuthKey, '_blank');
    win.focus();
  }

  //export partner customers report
  exportPartnerCustomers(start_dt, end_dt, portaluser_id, select_product, portaluser_name) {
    var win = window.open(this.state.apiUrl + '/PartnerRest/ExportPartnerCustomers/portaluser_id/' + portaluser_id + '/portaluser_name/' + portaluser_name + '/select_product/' + select_product + '/start_dt/' + start_dt + '/end_dt/' + end_dt + '/userAuthKey/' + this.state.userAuthKey, '_blank');
    win.focus();
  }

  checkedDemouser(event) {
    let isChecked = event.target.checked;
    console.log(event.target.checked);
    if (event.target.checked == true) {
      localStorage.setItem('checkedDemoUser', 1);
      this.setState({ demouser: event.target.checked }, function () {
        this.affiliatesList();
      });
    } else {
      localStorage.setItem('checkedDemoUser', 0);
      this.setState({ demouser: event.target.checked }, function () {
        this.affiliatesList();
      });
    }
  }

  visitSorting() {
    localStorage.setItem('sortingLeads', '');
    localStorage.setItem('sortingCustomers', '');
    this.setState({ iconStatusOfCustomers: 'fa fa-sort' });
    this.setState({ iconStatusOfLeads: 'fa fa-sort' });
    console.log(localStorage.getItem('sortingVisits'));
    if (localStorage.getItem('sortingVisits') == 1) {
      localStorage.setItem('sortingVisits', 2);
      this.setState({ iconStatusOfVisits: 'fa fa-arrow-up' });
      this.setState({ sortingVisits: 2 }, function () {
        this.affiliatesList();
      });
    } else {
      localStorage.setItem('sortingVisits', 1);
      this.setState({ iconStatusOfVisits: 'fa fa-arrow-down' });
      this.setState({ sortingVisits: 1 }, function () {
        this.affiliatesList();
      });
    }
  }

  leadsSorting() {
    localStorage.setItem('sortingVisits', '');
    localStorage.setItem('sortingCustomers', '');
    this.setState({ loading: true });
    this.setState({ iconStatusOfVisits: 'fa fa-sort' });
    this.setState({ iconStatusOfCustomers: 'fa fa-sort' });
    console.log(localStorage.getItem('sortingLeads'));
    if (localStorage.getItem('sortingLeads') == 1) {
      localStorage.setItem('sortingLeads', 2);
      this.setState({ iconStatusOfLeads: 'fa fa-arrow-up' });
      this.setState({ sortingLeads: 2 }, function () {
        this.affiliatesList();
      });
    } else {
      localStorage.setItem('sortingLeads', 1);
      this.setState({ iconStatusOfLeads: 'fa fa-arrow-down' });
      this.setState({ sortingLeads: 1 }, function () {
        this.affiliatesList();
      });
    }
  }

  customersSorting() {
    localStorage.setItem('sortingVisits', '');
    localStorage.setItem('sortingLeads', '');
    this.setState({ iconStatusOfVisits: 'fa fa-sort' });
    this.setState({ iconStatusOfLeads: 'fa fa-sort' });
    console.log(localStorage.getItem('sortingCustomers'));
    if (localStorage.getItem('sortingCustomers') == 1) {
      localStorage.setItem('sortingCustomers', 2);
      this.setState({ iconStatusOfCustomers: 'fa fa-arrow-up' });
      this.setState({ sortingCustomers: 2 }, function () {
        this.affiliatesList();
      });
    } else {
      localStorage.setItem('sortingCustomers', 1);
      this.setState({ iconStatusOfCustomers: 'fa fa-arrow-down' });
      this.setState({ sortingCustomers: 1 }, function () {
        this.affiliatesList();
      });
    }
  }

  componentDidMount() {
    document.title = "Intranet | Allaffilates";
    if (!localStorage.getItem('userLogin')) {
      this.setState({ redirect: true });
    }
    if (localStorage.getItem('checkedDemoUser') == 1) {
      console.log(1);
      this.state.demouser = true;
      console.log(this.state.demouser);
    } else {
      this.state.demouser = false;
      console.log(0);
      console.log(this.state.demouser);
    }
    this.affiliatesList();
  }
  render() {
    const { loading, resellers } = this.state;
    if (this.state.redirect) {
      return (
        <Redirect to={'/login'} />
      )
    }
    const { start, end } = this.state;
    const handleCallback = (start, end) => {
      this.setState({ start, end });
      // console.log('hi');
      this.setState({ start_dt: start.format("YYYY-MM-DD"), end_dt: end.format("YYYY-MM-DD") });
      console.log(start.format("YYYY-MM-DD"));
      console.log(end.format("YYYY-MM-DD"));
      this.datePickerChange(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
    };
    const label = start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY');
    return (
      <div>
        <Header brecum_name="partners" brecum_page="All Partners" />
        <div class="modal fade" id="myModal" role="dialog">
          <div class="modal-dialog modal-md">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title">Import Partners</h4>
              </div>
              <div class="modal-body">
                <p class="red">{this.state.importResponse ? this.state.importResponse : ''}</p>

                <form onSubmit={this._handleImport} method="POST">
                  <div class="form-group">
                    <div class="input-group">
                      <input type="hidden" id="filename" name="filename" value="" />
                      <input type="file" id="uploadedFile" name="uploadedFile" class="form-control form-control-sm" accept=".csv" onChange={this.importChange} />
                      <div class="input-group-btn">
                        <button type="submit" class="rounded-0 btn btn-primary">{this.state.uploadMessage ? this.state.uploadMessage : 'Upload'}</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <Link to={this.state.apiUrl + '/uploads/csv/partners-import-template.csv'} name={"max"} target="_blank" > <button className="btn btn-blue mob-btn" >Sample Download</button></Link>
              </div>
            </div>
          </div>
        </div>
        <div class="right_col">
          <div className="red">{this.state.message12}</div>
          <section class="customer">
            <div id="exTab1" class="container">
              <ul class="nav nav-pills">
                <li>
                  <Link to={`/allreseller/`} name={"max"} class="tab">All</Link>
                </li>
                <li>
                  <Link to={`/reseller/`} name={"max"} class="tab">Reseller</Link>
                </li>
                <li>
                  <Link to={`/managereferer/`} name={"max"} class="tab">Referrer</Link>
                </li>
                <li class="active">
                  <Link to={`/affiliates/`} name={"max"} class="tab">Affiliates</Link>
                </li>
              </ul>
              <div class="tab-content clearfix">
                <div class="tab-pane active" id="Leads">
                </div>
              </div>
            </div>


            <div class="row mt-20">
              <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <DateRangePicker
                  initialSettings={{
                    startDate: start.toDate(),
                    endDate: end.toDate(),
                    ranges: {
                      Today: [moment().toDate(), moment().toDate()],
                      Yesterday: [
                        moment().subtract(1, 'days').toDate(),
                        moment().subtract(1, 'days').toDate(),
                      ],
                      'Last 7 Days': [
                        moment().subtract(6, 'days').toDate(),
                        moment().toDate(),
                      ],
                      'Last 30 Days': [
                        moment().subtract(29, 'days').toDate(),
                        moment().toDate(),
                      ],
                      'This Month': [
                        moment().startOf('month').toDate(),
                        moment().endOf('month').toDate(),
                      ],
                      'Last Month': [
                        moment().subtract(1, 'month').startOf('month').toDate(),
                        moment().subtract(1, 'month').endOf('month').toDate(),
                      ],
                    },
                  }}
                  onCallback={handleCallback}
                >
                  <div id="reportrange">
                    <span class="range-datepicker form-control" style={{ lineHeight: "32px" }} >{label}</span>
                  </div>
                </DateRangePicker>
              </div>

              <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div class="cu_search">
                  <div class="react_auto">
                    <div class="ticket_search_box tsb-extra">
                      <input type="text" class="search_input" placeholder="Search partner name" id="searchkeyword" name="searchkeyword" onChange={this.keywordChange} autocomplete="off" />
                    </div>
                    <i class="fa fa-search"></i>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                <div class="filter">
                  <select class="form-control" onChange={this.handleProductSelect}>
                    <option value="">All Products</option>
                    <option value="3D28C83C85544F0D9517DD2E7C7EEDAA">Muvi One</option>
                    <option value="8E4F8A19B07D4F22927CD4CB54672D20">Muvi Live</option>
                    <option value="B05C552148D643158A8AD703B26331CC">Muvi Flex</option>
                    <option value="445fc3d5f1c6433eafc50e3bc946153e">Muvi Player</option>
                    <option value="7718F46772A54819AE19147BCE9D3D6B">Muvi Playout</option>
                    <option value="36ADB69786A940A2B745CE8B96A30BD7">Muvi Alie</option>
                  </select>
                  <i class="fal fa-angle-down"></i></div>
              </div>

              <div className="col-lg-1 col-md-1 col-sm-1 col-xs-6 onclick-menu demouser-div" tabindex="0">
                <i class="far fa-ellipsis-v"></i>
                <ul class="onclick-menu-content text-left demouser-popup">
                  <input type="checkbox" defaultChecked={this.state.checkedDemoUser == 1 ? 'checked' : ''} onChange={event => this.checkedDemouser(event)} />
                  <label class="demouser-checkbox">Show Demo User</label>
                </ul>
              </div>
            </div>


            <div class="int-box-wrapper">
              <div class="row">
                <div class="col-xs-12 col-sm-4">
                  <div class="int-box">
                    <div class="svg-box">
                      <svg width="60" height="61" viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M56.0157 40.7246L56.0098 40.7188L56.0039 40.7129C53.4199 35.2461 49.418 32.4336 44.0918 32.4336C38.7656 32.4336 34.7637 35.252 32.1738 40.7129V40.7188C31.8574 41.3926 31.8574 42.1777 32.1738 42.8516C34.7637 48.3125 38.7656 51.125 44.0918 51.125C49.418 51.125 53.42 48.3066 56.0098 42.8457C56.3262 42.1719 56.3262 41.3926 56.0157 40.7246ZM44.0918 47.375C40.4531 47.375 37.7988 45.6172 35.8242 41.7793C37.793 37.9414 40.4531 36.1836 44.0918 36.1836C47.7305 36.1836 50.3848 37.9414 52.3594 41.7793C50.3906 45.6172 47.7305 47.375 44.0918 47.375Z" fill="#5A738E" fill-opacity="0.4" />
                        <path d="M40.8398 41.8086C40.8398 42.6788 41.1855 43.5134 41.8009 44.1288C42.4163 44.7441 43.2509 45.0898 44.1211 45.0898C44.9913 45.0898 45.8259 44.7441 46.4413 44.1288C47.0566 43.5134 47.4023 42.6788 47.4023 41.8086C47.4023 40.9384 47.0566 40.1038 46.4413 39.4884C45.8259 38.873 44.9913 38.5273 44.1211 38.5273C43.2509 38.5273 42.4163 38.873 41.8009 39.4884C41.1855 40.1038 40.8398 40.9384 40.8398 41.8086Z" fill="#5A738E" fill-opacity="0.4" />
                        <path d="M7.96875 14.0938H49.2188V28.918H53.4375V11.75C53.4375 10.7129 52.5996 9.875 51.5625 9.875H5.625C4.58789 9.875 3.75 10.7129 3.75 11.75V42.2188C3.75 43.2559 4.58789 44.0938 5.625 44.0938H26.25V39.875H7.96875V14.0938Z" fill="#5A738E" fill-opacity="0.4" />
                        <path d="M42.4746 20.3106L40.3184 18.1543C40.1367 17.9727 39.8379 17.9727 39.6562 18.1543L28.8867 28.9356L23.8418 23.8848C23.6602 23.7031 23.3613 23.7031 23.1797 23.8848L14.7246 32.3399C14.543 32.5215 14.543 32.8203 14.7246 33.002L16.8809 35.1582C17.0625 35.3399 17.3613 35.3399 17.543 35.1582L23.5078 29.1934L28.5527 34.2442C28.7344 34.4258 29.0332 34.4258 29.2148 34.2442L42.4746 20.9727C42.6621 20.791 42.6621 20.4922 42.4746 20.3106Z" fill="#5A738E" fill-opacity="0.4" />
                      </svg>
                    </div>
                    <div class="int-box-right">
                      <h2>{this.state.total_visitors ? this.state.total_visitors : 0}</h2>
                      <p>Visits</p>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                  <div class="int-box">
                    <div class="svg-box">
                      <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.5 18.75C26.6421 18.75 30 15.3921 30 11.25C30 7.10786 26.6421 3.75 22.5 3.75C18.3579 3.75 15 7.10786 15 11.25C15 15.3921 18.3579 18.75 22.5 18.75Z" stroke="#5A738E" stroke-opacity="0.4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M39.375 41.25C39.375 31.9303 31.8197 24.375 22.5 24.375C13.1803 24.375 5.625 31.9303 5.625 41.25" stroke="#5A738E" stroke-opacity="0.4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M28.125 33.75L20.625 41.25L16.875 37.5" stroke="#5A738E" stroke-opacity="0.4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                    <div class="int-box-right">
                      <h2>{this.state.start_dt != '' && this.state.start_dt != '' ? <a href="javascript:void(1);" onClick={() => this.exportLeads(this.state.start_dt, this.state.end_dt, this.state.select_product)}>{this.state.total_leads}</a> : <a href="javascript:void(1);" onClick={() => this.exportLeads(this.state.start_dt, this.state.start_dt, this.state.select_product)}>{this.state.total_leads}</a>}</h2>
                      <p>Leads</p>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                  <div class="int-box">
                    <div class="svg-box">
                      <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.0625 11.75C20.3241 11.7569 18.659 12.4505 17.4297 13.6797C16.2005 14.909 15.5069 16.5741 15.5 18.3125C15.5 21.9163 18.4587 24.875 22.0625 24.875C25.6663 24.875 28.625 21.9163 28.625 18.3125C28.625 14.7088 25.6663 11.75 22.0625 11.75ZM38.9375 11.75C37.1991 11.7569 35.534 12.4505 34.3047 13.6797C33.0755 14.909 32.3819 16.5741 32.375 18.3125C32.375 21.9163 35.3337 24.875 38.9375 24.875C42.5412 24.875 45.5 21.9163 45.5 18.3125C45.5 14.7088 42.5412 11.75 38.9375 11.75ZM22.0625 15.5C23.6375 15.5 24.875 16.7375 24.875 18.3125C24.875 19.8875 23.6375 21.125 22.0625 21.125C20.4875 21.125 19.25 19.8875 19.25 18.3125C19.25 16.7375 20.4875 15.5 22.0625 15.5ZM38.9375 15.5C40.5125 15.5 41.75 16.7375 41.75 18.3125C41.75 19.8875 40.5125 21.125 38.9375 21.125C37.3625 21.125 36.125 19.8875 36.125 18.3125C36.125 16.7375 37.3625 15.5 38.9375 15.5ZM13.625 23C9.5 23 6.125 26.375 6.125 30.5C6.125 32.5869 7.01937 34.4694 8.41062 35.8325C7.13436 36.6937 6.08805 37.854 5.36287 39.2122C4.63769 40.5704 4.25564 42.0853 4.25 43.625H8C8 40.4975 10.4975 38 13.625 38C16.7525 38 19.25 40.4975 19.25 43.625H23C22.9944 42.0853 22.6123 40.5704 21.8871 39.2122C21.1619 37.854 20.1156 36.6937 18.8394 35.8325C20.2306 34.4694 21.125 32.5888 21.125 30.5C21.125 26.375 17.75 23 13.625 23ZM23 43.625C21.8281 45.1925 21.125 47.1631 21.125 49.25H24.875C24.875 46.1225 27.3725 43.625 30.5 43.625C33.6275 43.625 36.125 46.1225 36.125 49.25H39.875C39.8718 47.2221 39.2142 45.2493 38 43.625C37.3625 42.7756 36.5938 42.05 35.7144 41.4575C37.1056 40.0944 38 38.2138 38 36.125C38 32 34.625 28.625 30.5 28.625C26.375 28.625 23 32 23 36.125C23 38.2119 23.8944 40.0944 25.2856 41.4575C24.4079 42.0471 23.6353 42.7798 23 43.625ZM38 43.625H41.75C41.75 40.4975 44.2475 38 47.375 38C50.5025 38 53 40.4975 53 43.625H56.75C56.7444 42.0853 56.3623 40.5704 55.6371 39.2122C54.9119 37.854 53.8656 36.6937 52.5894 35.8325C53.9806 34.4694 54.875 32.5888 54.875 30.5C54.875 26.375 51.5 23 47.375 23C43.25 23 39.875 26.375 39.875 30.5C39.875 32.5869 40.7694 34.4694 42.1606 35.8325C40.8844 36.6937 39.8381 37.854 39.1129 39.2122C38.3877 40.5704 38.0056 42.0853 38 43.625ZM13.625 26.75C15.7194 26.75 17.375 28.4056 17.375 30.5C17.375 32.5944 15.7194 34.25 13.625 34.25C11.5306 34.25 9.875 32.5944 9.875 30.5C9.875 28.4056 11.5306 26.75 13.625 26.75ZM47.375 26.75C49.4694 26.75 51.125 28.4056 51.125 30.5C51.125 32.5944 49.4694 34.25 47.375 34.25C45.2806 34.25 43.625 32.5944 43.625 30.5C43.625 28.4056 45.2806 26.75 47.375 26.75ZM30.5 32.375C32.5944 32.375 34.25 34.0306 34.25 36.125C34.25 38.2194 32.5944 39.875 30.5 39.875C28.4056 39.875 26.75 38.2194 26.75 36.125C26.75 34.0306 28.4056 32.375 30.5 32.375Z" fill="#5A738E" fill-opacity="0.4" />
                      </svg>
                    </div>
                    <div class="int-box-right">
                      <h2>{this.state.start_dt != '' && this.state.start_dt != '' ? <a href="javascript:void(1);" onClick={() => this.exportCustomers(this.state.start_dt, this.state.end_dt, this.state.select_product)}>{this.state.total_customers}</a> : <a href="javascript:void(1);" onClick={() => this.exportCustomers(this.state.start_dt, this.state.start_dt, this.state.select_product)}>{this.state.total_customers}</a>}</h2>
                      <p>Customers</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="list_check">
              {this.state.loading && (
                <div>
                  <div class="loader-new"></div>
                </div>
              )}
              {!this.state.loading && (
                <div class="tickets hidden-xs">
                  <ul class="tickets_head adv">
                    <li class="intra_col_25">Partners Name</li>
                    <li class="intra_col_25">Visits </li>
                    <li class="intra_col_25">Leads </li>
                    <li class="intra_col_25">Customers </li>
                    <div class="clear"></div>
                  </ul>
                  {this.state.affiliates.map((affiliate) => (
                    <ul class="tickets_number">
                      <li class="intra_col_25 text-inded">
                        {<Link to={`/resellerCustomer/${affiliate.id}`} name={"max"}>
                          {affiliate.name}
                        </Link>}
                      </li>
                      <li class="intra_col_25 text-inded">{affiliate.Visitors ? affiliate.Visitors : 0}</li>
                      <li class="intra_col_25 text-inded">
                        {affiliate.Leads == 0 ? '0' : <a href="javascript:void(1);" onClick={() => this.exportPartnerLeads(this.state.start_dt, this.state.end_dt, affiliate.portaluser_id_att, this.state.select_product, affiliate.name)}> {affiliate.Leads}</a>}
                      </li>
                      <li class="intra_col_25">
                        {affiliate.Customers == 0 ? '0' : <a href="javascript:void(1);" onClick={() => this.exportPartnerCustomers(this.state.start_dt, this.state.end_dt, affiliate.portaluser_id_att, this.state.select_product, affiliate.name)}>{affiliate.Customers}</a>}
                      </li>
                    </ul>
                  ))}
                  {this.state.item_count > 0 ? (
                    <div class="pagination-muvi">
                      <Pagination
                        itemClass={'pages'}
                        itemClassFirst={'first_page'}
                        itemClassPrev={'prev_page'}
                        itemClassNext={'next_page'}
                        itemClassLast={'last_page'}
                        activePage={this.state.activePage}
                        itemsCountPerPage={10}
                        totalItemsCount={this.state.item_count}
                        pageRangeDisplayed={5}
                        onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                      />
                      <div style={{ color: "#333" }}>
                        {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center" style={{ color: "#333" }}>No Data Found</div>
                  )}
                </div>
              )}
            </div>
            <div class="clearfix"></div>
          </section>
        </div>
      </div>
    )
  }
}
export default Affiliates


// WEBPACK FOOTER //
// ./src/components/partner/affiliates.js